<template>
  <b-table
    :items="dataPays"
    :fields="fields"
    :key="updateUI"
    emptyText="Đơn chưa có thanh toán nào"
    show-empty
  >
    <template #cell(index)="data">
      <div>{{ data.index + 1 }}</div>
    </template>
    <template #cell(payMethod)="data">
      <div>{{ (allPayment[data.item.payMethod+"_"+data.item.payGateway] && allPayment[data.item.payMethod+"_"+data.item.payGateway].name) || data.item.payMethod }}</div>
    </template>
    <template #cell(amount)="data">
      <div>{{ formatMoney(divisionThousand(data.item.amount)) }}</div>
    </template>
    <template #cell(status)="data">
      <div class="text-center">
        <StatusBox class="m-auto" :status="getPaymentsStatus(data.item.status, data.item).status" :showText="getPaymentsStatus(data.item.status, data.item).text"></StatusBox>
      </div>
    </template>
    <template #cell(requestAt)="data">
      <div>{{ timeFormatDate(data.item.requestAt) }}</div>
    </template>
    <template #cell(gatewayTransactionId)="data">
      <div>{{ checkGatewayTransactionIdNotDebtNote(data.item) || "---" }}</div>
    </template>
  </b-table>
</template>

<script>
import StatusBox from '@/components/status-box.vue';
import { allPayment } from "@/utils/mapping";

export default {
  props: ["dataPays"],
  components: {
    StatusBox,
  },
  data() {
    return {
      allPayment: allPayment,
      updateUI: 1,
      fields: [
        {
          key: "index",
          label: "#",
          thStyle: { width: "2%" },
        },
        {
          key: "payMethod",
          label: "Phương thức",
          thStyle: { width: "4%" },
        },
        {
          key: "amount",
          label: "Số tiền thanh toán",
          thStyle: { width: "4%" },
        },
        {
          key: "status",
          label: "Trạng thái",
          thStyle: { width: "4%" },
          thClass: "text-center"
        },
        {
          key: "requestAt",
          label: "Thời gian",
          thStyle: { width: "4%" },
        },
        {
          key: "gatewayTransactionId",
          label: "Mã tham chiếu",
          thStyle: { width: "4%" },
        },
      ],
    }
  },
  methods: {
    getPaymentsStatus(status, item) {
      if(item && item.payMethod == "DEBT_NOTE") return {
        status: "COMPLETE",
        text: "Đã ghi nhận"
      }
      switch (status) {
        case "PROCESSING":
          return {
            status: "NEW",
            text: "Chờ thanh toán"
          }

        case "SUCCESS":
          return {
            status: "COMPLETE",
            text: "Đã thanh toán"
          }
      
        default:
          return {
            status: status,
            text: ""
          }
      }
    },
    checkGatewayTransactionIdNotDebtNote(data) {
      data.payMethod == "DEBT_NOTE" ? null : data.gatewayTransactionId
    }
  }
}
</script>

<style>

</style>